import { useQuery } from '@apollo/client'
import { GROUPS_QUERY } from 'components/common/analytics-report/GroupsQuery'
import { useStations } from 'components/common/hooks/useStations'
import { useAuth } from 'config/context/authContext'
import React, { createContext, useContext } from 'react'

const StationGroupsContext = createContext()

export const StationGroupsContextProvider = ({ retailerId, children }) => {
  const { isEdgeDataProUser } = useAuth()

  const { stations } = useStations()

  // Create group for all stations
  const allStationsGroup = [{
    id: 'all-stations',
    name: 'All Stations',
    childGroups: [
      {
        id: 'all-stations__all-stations',
        name: 'All Stations',
        stationGuids: stations.map(station => station.id),
      }
    ]
  }]

  const { data, error, loading } = useQuery(GROUPS_QUERY, {
    notifyOnNetworkStatusChange: true,
    variables: {
      retailerId,
    },
    fetchPolicy: 'network-only',
    skip: !retailerId || isEdgeDataProUser  // prevent query if retailerId is not yet ready or if account isn't an Edge Data Pro account (PoP disabled for Edge Data Pro accounts)
  })

  let groups = []

  if(data?.groups?.groups){
    groups = [...allStationsGroup, ...data?.groups?.groups]
  }

  return (
    <StationGroupsContext.Provider value={{ groups, loading, error }}>
      {children}
    </StationGroupsContext.Provider>
  )
}

export const useStationGroups = () => {
  const context = useContext(StationGroupsContext)
  if (!context) {
    return []
  }
  return context
}